import { PlatformSettingsFormShell } from '@app/modules/social-export/components/settings/PlatformSettingsFormShell';
import { BaseSettingsFormProps } from '@app/modules/social-export/hooks/social-export-form-props';
import { z } from 'zod';
import { TiktokSettingsDto, TiktokSettingsDtoPrivacyLevelEnumKey } from '../../social-export.types';
import { TikTokSettingsFields } from './components/TiktokSettingsFields';

export const tiktokSettingsSchema = z.object({
  privacyLevel: z.enum([
    'PUBLIC_TO_EVERYONE',
    'MUTUAL_FOLLOW_FRIENDS',
    'FOLLOWER_OF_CREATOR',
    'SELF_ONLY',
  ]),
  allowComment: z.boolean(),
  allowDuet: z.boolean(),
  allowStitch: z.boolean(),
});

export type TikTokSettingsFormValues = z.infer<typeof tiktokSettingsSchema>;

const defaultFormValues: TikTokSettingsFormValues = {
  privacyLevel: 'PUBLIC_TO_EVERYONE',
  allowComment: false,
  allowDuet: false,
  allowStitch: false,
};

function toFormValues(dto: TiktokSettingsDto | undefined): TikTokSettingsFormValues {
  if (!dto) return defaultFormValues;
  return {
    privacyLevel: (dto.privacyLevel ??
      'PUBLIC_TO_EVERYONE') as TikTokSettingsFormValues['privacyLevel'],
    allowComment: dto.allowComment ?? false,
    allowDuet: dto.allowDuet ?? false,
    allowStitch: dto.allowStitch ?? false,
  };
}

export function TikTokSettingsForm({
  onUpdate,
  defaultSettings,
}: BaseSettingsFormProps<TiktokSettingsDto>) {
  return (
    <PlatformSettingsFormShell
      values={toFormValues(defaultSettings)}
      schema={tiktokSettingsSchema}
      onSuccess={async (formData: TikTokSettingsFormValues) => {
        await onUpdate({
          privacyLevel: formData.privacyLevel as TiktokSettingsDtoPrivacyLevelEnumKey,
          allowComment: formData.allowComment,
          allowDuet: formData.allowDuet,
          allowStitch: formData.allowStitch,
        });
      }}
    >
      <TikTokSettingsFields />
    </PlatformSettingsFormShell>
  );
}
